import { EMPTY, MIN_SEARCH_LENGTH } from '../constants/search';

export function filterSearchResultsOffline(
  items,
  search,
  searchOwner,
  loggedTAId
) {
  const searchTerm = search.trim().toLowerCase();

  if (
    searchTerm === '' ||
    searchTerm === null ||
    searchTerm === undefined ||
    (searchOwner !== EMPTY && searchOwner !== loggedTAId) ||
    searchTerm.length < MIN_SEARCH_LENGTH
  ) {
    return [];
  }

  return items.filter((item) => {
    const {
      visitAddress: { name },
      clientNumber,
    } = item;

    return (
      name.toLowerCase().includes(searchTerm) ||
      clientNumber?.toLowerCase().includes(searchTerm)
    );
  });
}
